import { createContext, useCallback, useState } from "react";

import { classNames } from "../../utils";
import { ErrorLabel, ExplanationLabel } from "./FormInput";

type Props = {
  children: React.ReactNode;
  className?: string;
};

export const FormInputGroupContext = createContext({
  addGroupError: (_id: string, _error: React.ReactNode) => {},
  addGroupExplanation: (_id: string, _explanation: React.ReactNode) => {},
  inGroup: false,
  removeGroupError: (_id: string) => {},
  removeGroupExplanation: (_id: string) => {},
});

export default function FormInputGroup(props: Props) {
  const [errors, setErrors] = useState<Array<[string, React.ReactNode]>>([]);
  const [explanations, setExplanations] = useState<Array<[string, React.ReactNode]>>([]);

  const addGroupError = useCallback((id: string, error: React.ReactNode) => {
    setErrors((errors) => [...errors.filter(([recordId]) => recordId !== id), [id, error]]);
  }, []);

  const addGroupExplanation = useCallback((id: string, explanation: React.ReactNode) => {
    setExplanations((explanations) => [...explanations.filter(([recordId]) => recordId !== id), [id, explanation]]);
  }, []);

  const removeGroupError = useCallback((id: string) => {
    setErrors((errors) => [...errors.filter(([recordId]) => recordId !== id)]);
  }, []);

  const removeGroupExplanation = useCallback((id: string) => {
    setExplanations((explanations) => [...explanations.filter(([recordId]) => recordId !== id)]);
  }, []);

  return (
    <>
      <div className={classNames(props.className)}>
        <FormInputGroupContext.Provider
          value={{ addGroupError, addGroupExplanation, inGroup: true, removeGroupError, removeGroupExplanation }}
        >
          {props.children}
        </FormInputGroupContext.Provider>
      </div>
      <div className="-mt-6 mb-6 pt-1.5">
        {errors.map(([id, error]) => (
          <ErrorLabel key={id}>{error}</ErrorLabel>
        ))}
        {explanations.map(([id, explanation]) => (
          <ExplanationLabel key={id}>{explanation}</ExplanationLabel>
        ))}
      </div>
    </>
  );
}
